import React from 'react';
import { getCSSVariableValue } from '../utils/getCSSVariableValue.js';

const strokeColor = getCSSVariableValue('--fc-buttons');
const fillColor = getCSSVariableValue('--color-almostwhite');
const arrowColor = getCSSVariableValue('--fc-buttons');

function ArrowUp(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" {...props}>
            <circle cx="27" cy="27" r="26.5" transform="rotate(-90 27 27)" fill={fillColor} stroke={strokeColor} />
            <path d="M33.7273 22.0199L32.8892 22.858L27.9602 17.9148L27.9602 38L26.767 38L26.767 17.9148L21.8239 22.858L21 22.0199L27.3636 15.6562L33.7273 22.0199Z" fill={arrowColor} />
        </svg>
    );
}

export default ArrowUp;